<div class="header">
	<div class="type">
		<span>
			<strong> {{ "syncActions.type" | translate }}: </strong>
			<span>{{ syncAction | actionTypeName }} ({{ "syncActions.method." + syncAction.method | translate }})</span>
		</span>

		<span class="show-details" (click)="showPath$.next(!showPath$.value)">
			<i class="fa" [class.fa-chevron-down]="showPath$.value" [class.fa-chevron-up]="!showPath$.value"></i>
		</span>
	</div>

	@if (showPath$ | async) {
		<p class="details">
			<strong>id: </strong>
			<span>{{ syncAction.path?.split("/").pop() }}</span>
		</p>
	}
</div>

<div class="body">
	@if (resident$ | async; as resident) {
		<p>
			<strong>Resident: </strong><span>{{ resident.firstName }} {{ resident.name }}</span>
		</p>
	}
</div>

<footer class="muted-footer">
	@if (syncAction.user) {
		<span>
			<i class="fa fa-keyboard-o"></i>
			{{ syncAction.user.firstName }} {{ syncAction.user.name }}
		</span>
	}

	@if (date) {
		<time>
			<i class="fa fa-clock-o"></i>
			{{ date | date: "dd/MM HH:mm" }}
		</time>
	}
</footer>
